import DateSel from './DateSel';
import { Plus, Trash2 } from 'lucide-react';
import { uid } from '../lib/model';
import { DMG_CODES, CLS_COLOR, INSP_METHODS, worstCls, clsLabel } from '../lib/sewerInsp';

function DmgRow({ t, d, i, onPatch, onDel }) {
  return (
    <div className="si-row" data-testid={`sewer-dmg-row-${i}`} style={{ borderLeftColor: CLS_COLOR[d.cls] }}>
      <input inputMode="decimal" data-testid={`sewer-dmg-st-${i}`} placeholder={`${t.siSt} (m)`} value={d.st} onChange={(e) => onPatch({ st: e.target.value })} />
      <select data-testid={`sewer-dmg-code-${i}`} value={d.code} onChange={(e) => onPatch({ code: e.target.value })}>
        {DMG_CODES.map((c) => <option key={c} value={c}>{`${c} – ${t['dmg_' + c]}`}</option>)}
      </select>
      <select data-testid={`sewer-dmg-cls-${i}`} value={d.cls} onChange={(e) => onPatch({ cls: +e.target.value })}>
        {[0, 1, 2, 3, 4, 5].map((c) => <option key={c} value={c}>{clsLabel(t, c)}</option>)}
      </select>
      <input data-testid={`sewer-dmg-note-${i}`} placeholder={t.fitNote} value={d.note} onChange={(e) => onPatch({ note: e.target.value })} />
      <button type="button" className="icon-btn danger" data-testid={`sewer-dmg-del-${i}`} onClick={onDel}><Trash2 size={14} /></button>
    </div>
  );
}

// damage protocol per sewer reach (station from start manhole, main code, condition class)
export default function SewerInsp({ t, obj, patch }) {
  const ins = obj.insp || { method: 'tv', date: '', items: [] };
  const set = (p) => patch({ insp: { ...ins, ...p } });
  const upd = (id, p) => set({ items: ins.items.map((d) => (d.id === id ? { ...d, ...p } : d)) });
  const w = worstCls(ins);
  return (
    <div className="si-box" data-testid="sewer-insp-box">
      <div className="si-head">
        <b>🕳️ {t.siTitle}</b>
        {w != null && <span className="si-cls" style={{ background: CLS_COLOR[w] }} data-testid="sewer-insp-worst">{t.siWorst}: {w}</span>}
      </div>
      <div className="row">
        <select data-testid="sewer-insp-method" value={ins.method} onChange={(e) => set({ method: e.target.value })}>
          {INSP_METHODS.map((m) => <option key={m} value={m}>{t['siM_' + m]}</option>)}
        </select>
        <label className="si-date">{t.woodDate}<DateSel past={25} testid="sewer-insp-date" value={ins.date} onChange={(date) => set({ date })} /></label>
      </div>
      <small className="muted">{t.siHint}</small>
      {(ins.items || []).map((d, i) => <DmgRow key={d.id} t={t} d={d} i={i} onPatch={(p) => upd(d.id, p)} onDel={() => set({ items: ins.items.filter((x) => x.id !== d.id) })} />)}
      <button type="button" className="btn btn-outline btn-sm" data-testid="sewer-dmg-add-btn" onClick={() => set({ items: [...ins.items, { id: uid('dm'), st: '', code: 'BAB', cls: 3, note: '' }] })}><Plus size={14} /> {t.siAdd}</button>
    </div>
  );
}
